import call from "@brainspore/celadon-base/service/http";
import examConstants from "@/packages/exams/examConstants";
import { helper } from "@/packages/dashboard/utils";

export default {
  namespaced: true,
  state: {
    studentResults: [],
    programmeRegistration: {},
    studentBookings: [],
    examCenters: [],
    studentRegistrations: [],
    transcript: {},
    proforma: "",
    receipt: "",
    programmeNotes: "",
    unitsLoading: false,
    setupProgrammes: [],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    studentExamGetter: (state) => (setup) => state[setup],
  },
  actions: {
    unitsLoading: ({ commit }, payload) => {
      commit("MUTATE", { state: "unitsLoading", data: payload });
    },
    studentExamResults: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.EXAM_RESULTS, payload)
        .then((response) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "studentResults",
            data: response.data.data,
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    saveBooking: ({ dispatch }, data) => {
      dispatch("unitsLoading", true);
      call("post", examConstants.booking, data)
        .then((res) => {
          dispatch("unitsLoading", false);
          dispatch("currentProgramme");
          dispatch("studentRegistrations");
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          dispatch("unitsLoading", false);
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    removeBooking: ({ dispatch }, data) => {
      dispatch("unitsLoading", true);
      call("post", examConstants.booking, data)
        .then((res) => {
          dispatch("unitsLoading", false);
          dispatch("currentProgramme");
          dispatch("studentRegistrations");
          Event.$emit("ApiSuccess", res.data.message);
        })
        .catch((error) => {
          dispatch("unitsLoading", false);
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    // get student exam bookings
    studentBookings: ({ commit }) => {
      call("get", examConstants.EXAM_BOOKINGS)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "studentBookings", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    examBookingProforma({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      let decrypted = helper.decrypt(payload);
      call("get", examConstants.proforma(decrypted))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "proforma",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    transcripts: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", examConstants.EXAM_TRANSCRIPT, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "transcript",
            data: res.data.data,
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getHistoricalTranscript: ({ commit }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", examConstants.getHistoricalTranscript, payload)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "transcript",
            data: res.data.data,
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    currentProgramme: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.PROGRAMME_REGISTRATION)
        .then((res) => {
          commit("MUTATE", {
            state: "programmeRegistration",
            data: res.data.data
              .filter((el) => el.current && !el.invoiced)
              .shift(),
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    studentRegistrations: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.PROGRAMME_REGISTRATION)
        .then((res) => {
          commit("MUTATE", {
            state: "studentRegistrations",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    examCenters: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.EXAM_CENTERS)
        .then((res) => {
          commit("MUTATE", {
            state: "examCenters",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getExamReceipt({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.receipt(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "receipt",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getProgrammeNotes({ commit }, payload) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.notes(payload))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "programmeNotes",
            data: process.env.VUE_APP_TEMP_URL + res.data.data[0],
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    getUnits: ({ commit }) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", examConstants.UNITS)
        .then((res) => {
          commit("MUTATE", {
            state: "setupProgrammes",
            data: res.data.data,
          });
          commit("Dashboard/SET_LOADING", false, { root: true });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
  },
};
